<template>
  <div class="container-fluid">
    <div class="row mt-2">
      <div class="col-lg-12 bg-white border-radius-xl p-3">
        <div>
          <h4 class="text-center">Administración de Usuarios</h4>
          <hr class="horizontal dark" />
          <div class="d-flex justify-content-between">
            <div class="d-flex justify-content-start">
              <IconField>
                <InputIcon class="pi pi-search" @click="applyFilter" style="cursor: pointer;"/>
                <InputText v-model="dataTableDetail.filter" placeholder="Search" @keyup.enter="applyFilter" v-tooltip="'Introduce tu filtro y presiona Enter'"/>
              </IconField>
            </div>
            <div class="d-flex justify-content-end">
              <a class="btn btn-addiuva-dark" @click="iniciarCrearUsuario()">
                <i class="fas fa-plus"></i> &nbsp; Crear Nuevo Usuario
              </a>
            </div>
          </div>
          <Toast />
          <!-- stripedRows -->
          <DataTable
            :value="usuarios"
            :lazy="true"
            :totalRecords="totalRecords"
            :loading="loading"
            @lazyLoad="listUsers"
            @page="onPageChange"
            @sort="onSort"
            :paginator="true"
            :rows="10"
            :rowsPerPageOptions="[5, 10, 20, 50]"
            tableStyle="min-width: 50rem"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            currentPageReportTemplate="{currentPage} de {totalPages}"
          >
            <template #empty> <div class="text-gray">No hay usuarios que mostrar. </div></template>
            <Column field="email" header="Usuario/Email" sortable ></Column>
            <Column field="nombres" header="Nombres" sortable ></Column>
            <Column field="apellidos" header="Apellidos" sortable ></Column>
            <Column field="nombreRol" header="Rol" sortable ></Column>
            <Column field="nombreAgencia" header="Agencia" sortable ></Column>
            <Column field="logueado" header="Logueado" sortable >
                <template #body="{ data }">
                  <Tag :value="(data.logueado == true ? ' Si ' : ' No ')" :severity="getSeverity(data.logueado)" rounded/>
                </template>
            </Column>
            <Column field="activo" header="Activo" sortable >
                <template #body="{ data }">
                    <Tag :value="(data.activo ? 'ACTIVO' : 'INACTIVO')" :severity="getSeverity(data.activo)" rounded/>
                </template>
            </Column>
            <Column field="company" header="Acción" style="width: 5%">
              <template #body="{ data }">
                <SplitButton label="Acciones" icon="fas fa-ellipsis-h" :model="data.items" menuButtonIcon="fas fa-ellipsis-h"  text v-if="data.items.length > 0" />
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
    </div>
    <!-- Modal Dialogs -->
    <!-- Resetear Contraseña -->
    <Dialog v-model:visible="resetear.visible" modal header="Header" :style="{ width: '50rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
      <template #header>
          <div class="inline-flex align-items-center justify-content-center gap-2">
            <h5 class="text-bold white-space-nowrap text-addiuva-dark">Resetear Contraseña</h5>
          </div>
      </template>
      <div class="row">
        <div class="col-md-12">
          Esta seguro de Resetar la contraseña del usuario <b>{{resetear.nombres}} {{resetear.apellidos}}</b>? <br>
          <small>Se le enviara un correo electrónico a <b>{{resetear.email}}</b> xon su nueva contraseña temporal, una vez inicie sesión se le pedira cambiar su contraseña.</small>
        </div>
      </div>
      <template #footer>
        <button class="btn btn-light" style="margin-right:1rem;" @click="closeModalResetear()">
          <i class="fas fa-times pr-1"></i> Cancelar
        </button>
        <Button class="btn btn-addiuva-dark" type="button" label="Resetear Contraseña" icon="fas fa-unlock-alt pr-1" :loading="loadingButton" @click="resetearPassword" />
      </template>
    </Dialog>
    <!-- Crear/Editar Usuario -->
    <Dialog v-model:visible="editar.visible" modal header="Header" :style="{ width: '40%' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
      <template #header>
        <div class="inline-flex align-items-center justify-content-center gap-2">
          <h5 class="text-bold white-space-nowrap text-addiuva-dark" id="title-edit">{{editar.title.toUpperCase()}}</h5>
        </div>
      </template>
      <div class="row">
        <div class="col-md-8">
          <label for="email">Usuario/Email <span class="text-danger">*</span></label>
          <InputText id="email" class="form-control" v-model="editar.email"/>
        </div>
        <div class="col-md-4">
          <label for="editar-activo">Activo</label>
          <div class="pt-1">
            <InputSwitch v-model="editar.activo" id="editar-activo"/>
          </div>
        </div>
        <div class="col-md-12">
          <label for="nombres">Nombres <span class="text-danger">*</span></label>
          <InputText id="nombres" class="form-control" v-model="editar.nombres"/>
        </div>
        <div class="col-md-12">
          <label for="apellidos">Apellidos <span class="text-danger">*</span></label>
          <InputText id="apellidos" class="form-control" v-model="editar.apellidos"/>
        </div>
        <div class="col-md-12">
          <label for="apellidos">Rol <span class="text-danger">*</span></label>
          <vue-select
            :options="rolOptions"
            label="text"
            v-model="editar.idRol"
            :reduce="(option) => option.value"
          ></vue-select>
        </div>
        <div class="col-md-12">
          <label for="apellidos">Agencia <span class="text-danger">*</span></label>
          <vue-select
            :options="agenciaOptions"
            label="text"
            v-model="editar.idAgencia"
            :reduce="(option) => option.value"
          ></vue-select>
        </div>
        <div class="col-md-6">
          <label for="edad">Fecha de Nacimiento</label>
          <datepicker
            v-model="editar.fechaNacimiento"
            :="basicConfigDatePicker"
            :name="String(n)"
          ></datepicker>
        </div>
        <div class="col-md-6">
          <label for="documento">Documento</label>
          <InputText id="documento" class="form-control" v-model="editar.nroDocumento"/>
        </div>
        <div class="col-md-6">
          <label for="telefono">Teléfono</label>
          <InputNumber v-model="editar.telefono" id="telefono" :useGrouping="false" class="w-100"/>
        </div>
      </div>
      <template #footer>
        <button class="btn btn-light" style="margin-right:1rem;" @click="closeModal()">
          <i class="fas fa-times pr-1"></i> Cancelar
        </button>
        <button class="btn btn-addiuva-dark" @click="editarUsuario" v-if="editar.id">
          <i class="fas fa-pen pr-1"></i> Editar
        </button>
        <button class="btn btn-addiuva-dark" @click="crearUsuario" v-if="!editar.id">
          <i class="fas fa-save pr-1"></i> Guardar
        </button>
      </template>
    </Dialog>
  </div>
</template>

<script>
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import VueSelect from "vue-select";
import Tag from 'primevue/tag';
import Toast from 'primevue/toast';
import SplitButton from 'primevue/splitbutton';
import Dialog from 'primevue/dialog';
import InputText from 'primevue/inputtext';
import InputNumber from 'primevue/inputnumber';
import Datepicker from 'vuejs3-datepicker';
import InputSwitch from 'primevue/inputswitch';
import Button from 'primevue/button';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import axios from 'axios';
import authHeader from '../services/auth-header';
// import moment from "moment"
export default {
  name: "Administración de Usuarios",
  components: {
    VueSelect,
    DataTable,
    Column,
    Tag,
    Toast,
    SplitButton,
    Button,
    Dialog,
    InputText,
    InputNumber,
    Datepicker,
    InputSwitch,
    IconField,
    InputIcon
  },
  data() {
    return {
      API_URL: process.env.VUE_APP_API_BASE_URL,
      showProfileDropdown: false,
      usuarios: [],
      resetear: {
        visible: false,
        id: null,
        nombres: null,
        apellidos: null,
        email: null
      },
      editar: {
        visible: false,
        title: null,
        id: null,
        idPersona: null,
        nombres: null,
        apellidos: null,
        fechaNacimiento: null,
        nroDocumento: null,
        telefono: null,
        email: null,
        idRol: null,
        idAgencia: null,
        activo: null,
      },
      rolOptions: [],
      agenciaOptions: [],
      basicConfigDatePicker: {
        "language": "es",
        "full-month-name":true,
        "monday-first": true,
        "iconWidth": "18",
        "iconHeight": "18",
        "use-utc": true,
      },
      loadingButton: false,
      loading: false,
      totalRecords: 0,
      dataTableDetail: {
        filter: null,
        page: 0,
        rows: 10,
        first: 0,
        sortField: null,
        sortOrder: null,
      }
    };
  },
  methods: {
    onPageChange(event){
      console.log("Evento:", event);
      console.log("Página actual:", event.page + 1); // Se suma 1 porque está indexado desde 0
      this.dataTableDetail.page = event.page;
      this.dataTableDetail.first = event.first;
      this.dataTableDetail.rows = event.rows;
      console.log("Primer registro:", event.first);
      console.log("Filas por página:", event.rows);
      console.log("Total de páginas:", event.pageCount);

      // Llama a la función para cargar los datos con los nuevos parámetros de paginación
      this.listUsers();
    },
    onSort(event){
      this.dataTableDetail.sortField = event.sortField;
      this.dataTableDetail.sortOrder = event.sortOrder;
      console.log("Campo ordenado:", event.sortField);
      console.log("Orden:", event.sortOrder);
      // console.log("Evento:", event);

      // Llama a la función para cargar los datos con los nuevos parámetros de orden
      this.listUsers();
    },
    applyFilter() {
      console.log("Filtro:", this.filter);
      // Llama a la función para cargar los datos con los nuevos parámetros de filtro
      this.listUsers();
    },
    async listUsers() {
      this.usuarios = [];
      this.loading = true;
      console.log('dataTableDetail');
      console.log(this.dataTableDetail);
      // Send Data by Axios
      let url = this.API_URL + "/usuarios";
      await axios({
        url: url,
        method: 'get',
        headers: authHeader(),
        params: {
          page: this.dataTableDetail.page,
          rows: this.dataTableDetail.rows,
          first: this.dataTableDetail.first,
          sortField: this.dataTableDetail.sortField,
          sortOrder: this.dataTableDetail.sortOrder,
          filter: this.dataTableDetail.filter
        }
      })
      .then(response => {
        if (response.data.status) {
            let data = response.data.data;
            let usuarios = [];
            data.forEach(a => {
              usuarios.push({
                id: a.id_usuario ?? '',
                idPersona: a.id_persona ?? '',
                nombres: a.persona.nombres ?? '',
                apellidos: a.persona.apellidos ?? '',
                fechaNacimiento: a.persona.fecha_nacimiento ?? '',
                nroDocumento:  a.persona.numero_documento ?? '',
                telefono: a.persona.telefono ?? '',
                email: a.persona.email ?? '',
                idRol: a.id_rol ?? '',
                nombreRol: a.nombre_rol ?? '',
                idAgencia: a.id_agencia ?? '',
                nombreAgencia: a.nombre_agencia ?? '',
                logueado: a.logueado ?? '',
                activo: a.activo ?? '',
              });
            });
            usuarios.forEach(user => {
              user.items = this.subMenuDefault(user);
            });
            this.usuarios = usuarios;
            this.loading = false;
            this.totalRecords = usuarios.length;
        }
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    },
    getRoles() {
      this.rolOptions = [];
      // Send Data by Axios
      let url = this.API_URL + "/roles/listar";
      axios({
        url: url,
        method: 'post',
        data: {},
        headers: authHeader(),
      })
      .then(response => {
        if (response.data.status) {
            let roles = [];
            response.data.data.forEach(element => {
              roles.push({ text: element.nombre, value: element.id_rol });
            });
            this.rolOptions = roles
        }
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    },
    getAgencias() {
      this.rolOptions = [];
      // Send Data by Axios
      let url = this.API_URL + "/agencias/lista";
      axios({
        url: url,
        method: 'post',
        data: {},
        headers: authHeader(),
      })
      .then(response => {
        if (response.data.status) {
            let agencias = [];
            response.data.data.forEach(element => {
              agencias.push({ text: element.nombre, value: element.id_agencia });
            });
            this.agenciaOptions = agencias
        }
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    },
    subMenuDefault(data) {
      let items = [
        {
          label: 'Editar',
          icon: 'fas fa-pen',
          command: () => {
              this.iniciarEdicion(data)
          }
        },
        {
          label: 'Resetear Contraseña',
          icon: 'fas fa-unlock-alt',
          command: () => {
              this.iniciarResetear(data);
          }
        }
      ];
      return items;
    },
    getSeverity(status) {
      let severity = null;
      if (status == true) severity = "success";
      if (status == false) severity = "danger";
      return severity;
    },
    capitalize(str) {
      const str2 = str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
      return str2;
    },
    // Resetear Contraseña
    iniciarResetear(data) {
        this.resetear.visible = true,
        this.resetear.id = data.id
        this.resetear.nombres = data.nombres
        this.resetear.apellidos = data.apellidos
        this.resetear.email = data.email
    },
    closeModalResetear() {
      this.resetear = {
        visible: false,
        id: null,
        nombres: null,
        apellidos: null,
        email: null
      };
    },
    resetearPassword() {
      if (this.resetear.id == null) {
        this.$toast.add({ severity: 'error', summary: 'Error', detail: 'A ocurrido un error, datos no encontrados', life: 3000 });
        return true;
      }
      let payload = {
        "id_usuario": this.resetear.id
      }
      // Send Data by Axios
      let url = this.API_URL + "/usuarios/resetContrasena";
      this.loadingButton = true;
      axios({
        url: url,
        method: 'post',
        data: payload,
        headers: authHeader(),
      })
      .then(response => {
        this.loadingButton = false;
        if (response.data.status) {
            this.$toast.add({ severity: 'success', summary: 'Exito', detail: 'Se envío un email al usuario con su nueva contraseña temporal.', life: 3000 });
            this.closeModalResetear();
            this.listUsers()
        } else {
          this.$toast.add({ severity: 'error', summary: 'Error', detail: 'No se pudo procesar su solicitud', life: 3000 });
        }
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    },
    // Edicion
    iniciarEdicion(data) {
      this.editar = {
        visible: true,
        title: 'Editar Usuario',
        id: data.id,
        idPersona: data.idPersona,
        nombres: data.nombres,
        apellidos: data.apellidos,
        fechaNacimiento: this.formatDate(data.fechaNacimiento),
        nroDocumento: data.nroDocumento,
        telefono: data.telefono,
        email: data.email,
        idRol: data.idRol,
        idAgencia: data.idAgencia,
        activo: data.activo
      };
      this.getRoles();
      this.getAgencias();
    },
    closeModal() {
      this.editar = {
        visible: false,
        title: null,
        id: null,
        idPersona: null,
        nombres: null,
        apellidos: null,
        fechaNacimiento: null,
        nroDocumento: null,
        telefono: null,
        email: null,
        idRol: null,
        idAgencia: null,
        activo: null,
      };
    },
    editarUsuario() {
      if (this.editar.id == null) {
        this.$toast.add({ severity: 'error', summary: 'Error', detail: 'A ocurrido un error, datos no encontrados', life: 3000 });
        return true;
      }
      let payload = {
        "persona": {
            "nombres": this.editar.nombres,
            "apellidos": this.editar.apellidos,
            "fecha_nacimiento": this.editar.fechaNacimiento,
            "numero_documento": this.editar.nroDocumento,
            "telefono": this.editar.telefono.toString(),
            "email": this.editar.email,
        },
        "password": 'sample',
        "activo": this.editar.activo,
        "id_rol": this.editar.idRol,
        "id_agencia": this.editar.idAgencia,
      }
      // Send Data by Axios
      let url = this.API_URL + "/usuarios/" + this.editar.id;
      axios({
        url: url,
        method: 'put',
        data: payload,
        headers: authHeader(),
      })
      .then(response => {
        if (response.data.status) {
            this.$toast.add({ severity: 'success', summary: 'Exito', detail: 'La Edición fue procesada exitosamente', life: 3000 });
            this.closeModal();
            this.listUsers()
        } else {
          this.$toast.add({ severity: 'error', summary: 'Error', detail: 'No se pudo procesar su solicitud', life: 3000 });
        }
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    },
    crearUsuario() {
      if (this.editar.id != null) {
        this.$toast.add({ severity: 'error', summary: 'Error', detail: 'A ocurrido un error.', life: 3000 });
        return true;
      }
      let payload = {
        "persona": {
            "nombres": this.editar.nombres,
            "apellidos": this.editar.apellidos,
            "fecha_nacimiento": this.editar.fechaNacimiento,
            "numero_documento": this.editar.nroDocumento,
            "telefono": this.editar.telefono ? this.editar.telefono.toString() : '',
            "email": this.editar.email,
        },
        "password": 'sample',
        "activo": this.editar.activo,
        "id_rol": this.editar.idRol,
        "id_agencia": this.editar.idAgencia,
      }
      // Send Data by Axios
      let url = this.API_URL + "/usuarios";
      axios({
        url: url,
        method: 'post',
        data: payload,
        headers: authHeader(),
      })
      .then(response => {
        if (response.data.status) {
            this.$toast.add({ severity: 'success', summary: 'Exito', detail: 'El usuario fue creado exitosamente', life: 3000 });
            this.closeModal();
            this.listUsers()
        } else {
          this.$toast.add({ severity: 'error', summary: 'Error', detail: 'No se pudo procesar su solicitud', life: 3000 });
        }
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    },
    // Restauración
    iniciarCrearUsuario() {
      this.getRoles();
      this.getAgencias();
      this.editar = {
        visible: true,
        title: 'Crear Usuario',
        id: null,
        idPersona: null,
        nombres: null,
        apellidos: null,
        fechaNacimiento: null,
        nroDocumento: null,
        telefono: null,
        email: null,
        idRol: null,
        idAgencia: null,
        activo: true,
      }
    },
    formatDate: function (date) {
      let aDate = date.split('/');
      return new Date(aDate[2], parseInt(aDate[1])-1, aDate[0]);
    },
    validateRoute(){
      let menus = this.getProfileMe.data.menu.filter( menu => {
        return (menu.path.toLowerCase().indexOf(this.$route.path.substring(1)) != -1);
      });
      if ( menus.length == 0 ) {
        this.$router.push({name: 'Dashboard'});
      }
    }
  },
  computed: {
    getProfileMe() {
      return this.$store.getters["profile/me"];
    }
  },
  watch: {
    filter: function (val) {
      console.log("Filtro:", val);
    }
  },
  mounted() {
    this.validateRoute();
    this.listUsers();
  }
};
</script>
<style>
.p-splitbutton-defaultbutton{
  display: none !important;
}
.p-button-icon-only {
  border-radius: 50px !important;
}
.vuejs3-datepicker__calendar {
  position: relative !important;
}
</style>